<div id="main-content" *ngIf="afDisclosureInfo ; else loading" class="wrapper has-padding margin-height zoom-margin"
  (focusout)="onFocusOutMainContent($event)">
  <form [formGroup]="ackData" (ngSubmit)="onSubmit()">

    <h1 class="bofa--heading is-4 double-bottom-space">Acknowledgment of Employment Terms and Information</h1>

    <div *ngIf="afDisclosureInfo.relativeFlag != -1">

      <div class="bottom-space">
        <div class="label-space" id="relative-radio-group-label"><abbr title="required">* </abbr>{{ ackRelatives }}
        </div>
        <mat-radio-group name="radioRelatives" aria-labelledby="relative-radio-group-label" formControlName="relatives"
          required (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)"
          (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value="1" name="relatives">Yes
          </mat-radio-button>
          <mat-radio-button class="minor-radio-padding" value="0" name="relatives">No</mat-radio-button>
          <mat-error *ngIf="hasBeenSubmitted && ackData.controls.relatives.hasError('required')">Please select if you
            have any relatives working for Bank of America</mat-error>
        </mat-radio-group>
      </div>

      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmitted && showRadioRelatives"> Please select if you have any relatives working for
          Bank of America </mat-error>
      </div>

      <div class="bottom-space" *ngIf="ackData.controls.relatives.value == 1">
        <div class="flex-container">
          <div class="fx-flex-40">
            <h3 class="bofa--heading is-5">Relatives</h3>
          </div>
          <div class="fx-flex-60">
            <div class="padding-top" class="padding-left-5"> <button [disabled]="relativeList.invalid" type="button"
                class="bofa--button secondary" (click)="createRelative()">Add Relative</button>
            </div>
          </div>
        </div>

        <!-- show horizonally -->
        <mat-list *ngIf="!relativeListChange">
          <mat-list-item *ngFor="let relativeForm of relativeList.controls; let i = index" [formGroup]="relativeForm">
            <mat-form-field class="max-zoom formfield-width-margin" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Relative Name</mat-label>
              <input matInput formControlName="relativeName" required>
              <mat-error>Please enter Relative Name
              </mat-error>
            </mat-form-field>

            <mat-form-field class="max-zoom formfield-width-margin" hideRequiredMarker>
              <mat-label><abbr title="required">* </abbr>Relationship</mat-label>
              <mat-select formControlName="relationship" required>
                <mat-option>Select</mat-option>
                <mat-option *ngFor="let relationship of afDisclosureInfo.relationshipLookup | keyvalue : idAscOrder"
                  [value]="relationship.key">
                  {{relationship.value}}
                </mat-option>
              </mat-select>
              <mat-hint class="bofa--skiplink">{{ dropDownScreenReaderRelative(relativeForm) }}</mat-hint>
              <mat-error *ngIf="relativeForm.controls.relationship.hasError('required')">Please select Relationship
              </mat-error>
            </mat-form-field>

            <div class="is-taller" class="padding-left-30">
              <button type="button" class="bofa--button primary outlined" (click)="deleteClick(i)">Remove this
                Relative</button>
            </div>
          </mat-list-item>
        </mat-list>

        <!-- show vertically -->
        <div *ngIf="relativeListChange">
          <ng-container *ngFor="let relativeForm of relativeList.controls; let i = index" [formGroup]="relativeForm">
            <mat-list-item>
              <mat-form-field class="max-zoom formfield-width-margin" hideRequiredMarker>
                <mat-label><abbr title="required">* </abbr>Relative Name</mat-label>
                <input matInput formControlName="relativeName" required>
                <mat-error *ngIf="relativeForm.controls.relativeName.hasError('required')">Please enter Relative Name
                </mat-error>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item>
              <mat-form-field class="max-zoom formfield-width-margin" hideRequiredMarker>
                <mat-label><abbr title="required">* </abbr>Relationship</mat-label>
                <mat-select formControlName="relationship" required>
                  <mat-option>Select</mat-option>
                  <mat-option *ngFor="let relationship of afDisclosureInfo.relationshipLookup | keyvalue : idAscOrder"
                    [value]="relationship.key">
                    {{relationship.value}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="relativeForm.controls.relationship.hasError('required')">Please select Relationship
                </mat-error>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item>
              <div class="is-taller" class="padding-left-30">
                <button type="button" class="bofa--button primary outlined" (click)="deleteClick(i)">Remove this
                  Relative</button>
              </div>
            </mat-list-item>
          </ng-container>
        </div>
      </div>
    </div>

    <div *ngIf="afDisclosureInfo.pendingInvestigationFlag != -1">
      <div class="bottom-space">
        <div class="label-space" id="pending-radio-group-label"><abbr title="required">* </abbr>{{ ackPendingInvest }}
        </div>
        <mat-radio-group name="radioInvestigation" aria-labelledby="pending-radio-group-label"
          formControlName="investigation" required (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)"
          (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value="1" name="investigation">
            Yes</mat-radio-button>
          <mat-radio-button class="minor-radio-padding" value="0" name="investigation">No</mat-radio-button>
          <mat-error *ngIf="hasBeenSubmitted && ackData.controls.investigation.hasError('required')">Please select if
            you have a pending
            investigation</mat-error>
        </mat-radio-group>
      </div>

      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmitted && showRadioInvestigation"> Please select if you have a pending
          investigation </mat-error>
      </div>

      <div class="padding-top" *ngIf="ackData.controls.investigation.value == 1">
        <mat-form-field class="max-zoom formfield-width-margin" hideRequiredMarker>
          <mat-label id="commentsLabel"><abbr title="required">* </abbr>Comments</mat-label>
          <textarea matInput formControlName="investigationComments" required maxlength="1000"
            aria-labelledby="commentsLabel"></textarea>
          <mat-error>Please enter comments</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="afDisclosureInfo.directorFlag != -1 && afDisclosureInfo.skinnyFlag != 1">
      <div class="bottom-space">
        <div class="label-space" id="director-radio-group-label"><abbr title="required">* </abbr>{{ ackObaodDirector }}
        </div>
        <mat-radio-group name="radioOutsideBusinessQuestion1" aria-labelledby="director-radio-group-label"
          formControlName="outsideBusinessQuestion1" required (change)="radioOnChange($event)"
          (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value="1"
            name="outsideBusinessQuestion1">Yes</mat-radio-button>
          <mat-radio-button class="minor-radio-padding" value="0" name="outsideBusinessQuestion1">No</mat-radio-button>
          <mat-error *ngIf="hasBeenSubmitted && ackData.controls.outsideBusinessQuestion1.hasError('required')">Please
            select if you are
            currently serving</mat-error>
        </mat-radio-group>
      </div>

      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmitted && showRadioOutsideBusinessQuestion1"> Please select if you are currently
          serving </mat-error>
      </div>

      <div>
        <p class="bofa--heading is-9 double-bottom-space">*"Director" means any service involving the ability to control
          an organization's governance
          and/or a duty (fiduciary or otherwise) to the organization itself and its investors, such as a director,
          managing member, operating board
          member, manager, advisory board member, investment committee member, or like service.</p>
      </div>
    </div>

    <div *ngIf="afDisclosureInfo.directorFlag != -1 && afDisclosureInfo.skinnyFlag != 1">
      <div class="bottom-space">
        <div class="label-space" id="disclosure-radio-group-label"><abbr title="required">*
          </abbr>{{ ackObaodCompensation }}</div>
        <mat-radio-group name="radioEmployedCompensated" aria-labelledby="disclosure-radio-group-label"
          formControlName="employedCompensated" required (change)="radioOnChange($event)"
          (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value="1"
            name="employedCompensated">Yes</mat-radio-button>
          <mat-radio-button class="minor-radio-padding" value="0" name="employedCompensated">No</mat-radio-button>
          <mat-error *ngIf="hasBeenSubmitted && ackData.controls.employedCompensated.hasError('required')">Please
            select if you are
            receiving other compensation</mat-error>
        </mat-radio-group>
      </div>

      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmitted && showRadioEmployedCompensated"> Please select if you are receiving other
          compensation </mat-error>
      </div>
    </div>

    <div *ngIf="afDisclosureInfo.raceFlag != -1">

      <h2 class="bofa--heading is-5">Ethnic Origin</h2>

      <div>
        <p class="bofa--heading is-8"> {{ ackEthnicity }} </p>
      </div>

      <div>
        <mat-form-field class="max-zoom formfield-width-margin" hideRequiredMarker>
          <mat-label>Ethnicity</mat-label>
          <mat-select formControlName="race">
            <mat-option>Select</mat-option>
            <mat-option *ngFor="let ethType of raceLookup | keyvalue" [value]="ethType.key">
              {{ethType.value}}
            </mat-option>
          </mat-select>
          <mat-hint class="bofa--skiplink">{{ dropDownScreenReaderEth() }}</mat-hint>
          <mat-error *ngIf="ackData.controls.race.hasError('required')">Please select Ethnicity</mat-error>
        </mat-form-field>
      </div>

      <div>
        <ul class="bofa--heading is-9 double-bottom-space">
          <li class="minor-list-space">*<strong>Asian (not Hispanic or Latino)</strong> - All persons having origins in
            any of the original peoples of
            Far East, Asia, or the Indian subcontinent. These areas include, for example, China, India, Japan or Korea
          </li>
          <li class="minor-list-space"><strong>Black/African American (not Hispanic or Latino)</strong> - All persons
            having origins in any of the Black
            racial groups of Africa</li>
          <li class="minor-list-space"><strong>Hispanic or Latino</strong> - All persons of Mexican, Puerto Rican,
            Cuban,
            Central or South American or
            Spanish origin regardless of race</li>
          <li class="minor-list-space"><strong>American Indian or Alaskan Native (not Hispanic or Latino)</strong> - All
            persons having origins in any of the
            original peoples of North America
            and who maintain cultural identification through tribal affiliation or community recognition</li>
          <li class="minor-list-space"><strong>Native Hawaiian or other Pacific Islander (not Hispanic or
              Latino)</strong>
            - All persons having origins in
            the Hawaiian Islands or other Pacific Islands</li>
          <li class="minor-list-space"><strong>Two or More Races</strong> - not of Hispanic or Latino origin</li>
          <li class="minor-list-space"><strong>White (not Hispanic or Latino)</strong> - All persons having origins in
            any
            of the original peoples of Europe,
            North Africa or the Middle East</li>
        </ul>
      </div>
    </div>

    <div>
      <div class="bottom-space padding-top">
        <div>
          <button #pdfButton type="button" class="bofa--button secondary outlined" title="Required to view Acknowledgment of Consent" (click)="downloadAcknowledgmentPDF()"><abbr title="required">* </abbr>Download and view
            Acknowledgement of Consent</button>

          <mat-checkbox class="minor-check-padding" [checked]="termsCheck" [disabled]="true" aria-label="Acknowledgement Confirmed"></mat-checkbox>
        </div>

        <div *ngIf="!termsCheck && hasBeenSubmitted" class="padding-top">
          <mat-error>Please download and view Acknowledgement of Consent to continue</mat-error>
        </div>
      </div>

      <div class="padding-top">
        <mat-checkbox aria-required="true" class="minor-check-padding" required (focusout)="termsOnBlur()"
          (focusin)="termsOnFocus()" formControlName="discTermsCheck">
          <mat-label class="white-space-normal"><abbr title="required">* </abbr>Yes, I certify that I have read and
            understand the information presented
          </mat-label>
          <mat-error class="white-space-normal" *ngIf="discTermsCheck.hasError('invalid') && check">Please check the
            box to agree to the above language</mat-error>
        </mat-checkbox>

        <mat-form-field class="margin-left-space max-zoom radio-padding formfield-width-margin">
          <mat-label>Date Signed</mat-label>
          <input value="{{ termDate }}" matInput disabled>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="afDisclosureInfo.revolvingDoorFlag != -1">
      <h2 class="bofa--heading is-5">Revolving Door</h2>

      <div>
        <p class="bofa--heading is-8"> {{ ackRevolvingDoor }} </p>
      </div>

      <div class="bottom-space">
        <div class="label-space" id="revolving-radio-group-label"><abbr title="required">*
          </abbr>{{ ackRevolvingDoor1 }}</div>
        <mat-radio-group name="radioEmployeeOfEntity" aria-labelledby="revolving-radio-group-label"
          formControlName="employeeOfEntity" required (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)"
          (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value="1"
            name="employeeOfEntity">Yes</mat-radio-button>
          <mat-radio-button class="minor-radio-padding" value="0" name="employeeOfEntity">No</mat-radio-button>
          <mat-error *ngIf="hasBeenSubmitted && ackData.controls.employeeOfEntity.hasError('required')">Please select
            the appropriate response</mat-error>
        </mat-radio-group>
      </div>

      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmitted && showRadioEmployeeOfEntity"> Please select the appropriate response
        </mat-error>
      </div>

      <div class="padding-top" *ngIf="ackData.controls.employeeOfEntity.value == 1">
        <mat-form-field class="max-zoom formfield-width-margin" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>{{ ackRevolvingDoor1A }}</mat-label>
          <input matInput formControlName="positionInEntity" required maxlength="100">
          <mat-error>Please state your position</mat-error>
        </mat-form-field>

        <mat-form-field class="max-zoom formfield-width-margin" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>{{ ackRevolvingDoor1B }}</mat-label>
          <input matInput formControlName="nameOfEntity" required maxlength="100">
          <mat-error>Please state the governement entity</mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="ackData.controls.employeeOfEntity.value == 1">
        <div class="label-space" id="employee-radio-group-label"><abbr title="required">* </abbr>{{ ackRevolvingDoor2 }}
        </div>
        <mat-radio-group name="radioContactWithEntity" aria-labelledby="employee-radio-group-label"
          formControlName="contactWithEntity" required (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)"
          (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value="1"
            name="contactWithEntity">Yes</mat-radio-button>
          <mat-radio-button class="minor-radio-padding" value="0" name="contactWithEntity">No</mat-radio-button>
          <mat-error *ngIf="hasBeenSubmitted && ackData.controls.contactWithEntity.hasError('required')">Please select
            the appropriate
            response</mat-error>
        </mat-radio-group>
      </div>

      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmitted && showRadioContactWithEntity"> Please select the appropriate response
        </mat-error>
      </div>

      <div class="padding-top"
        *ngIf="ackData.controls.contactWithEntity.value == 1 && ackData.controls.employeeOfEntity.value == 1">
        <mat-form-field class="max-zoom formfield-width-margin" hideRequiredMarker>
          <mat-label id="ackRevolvingDoor2A"><abbr title="required">* </abbr>{{ ackRevolvingDoor2A }}</mat-label>
          <textarea matInput formControlName="entityDetails" required maxlength="1000"
            aria-labelledby="ackRevolvingDoor2A"></textarea>
          <mat-error>Please provide details</mat-error>
        </mat-form-field>
      </div>
    </div>

    <p class="bofa--heading is-8">By signing below you acknowledge that you have fully reviewed and completed the
      information above</p>

    <div class="div-width-margin" *ngIf="afDisclosureInfo">
      <app-wet-signature [signatureImg]="signatureImg" (sigURL)="getUrl($event)"
        (sigCheck)="sigCheck($event)">
      </app-wet-signature>
      <mat-error *ngIf="output.hasError('invalid') || sigCheckValue"> Please enter electronic signature </mat-error>
    </div>

    <mat-checkbox aria-required="true" required (focusout)="legalOnBlur()" (focusin)="legalOnFocus()"
      formControlName="legalRequirementsMet" class="minor-check-padding">
      <mat-label class="white-space-normal"><abbr title="required">* </abbr>Yes, I agree that I have fully reviewed and
        completed the information above
      </mat-label>
    </mat-checkbox>
    <mat-error class="white-space-normal" *ngIf="legalRequirementsMet.hasError('invalid') && checkTwo"> Please check
      the box to agree to the above language </mat-error>

    <div>
      <mat-form-field class="max-zoom formfield-width-margin" hideRequiredMarker>
        <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
        <input matInput placeholder="Full name" formControlName="applicantSignedName" required maxlength="250">
        <mat-error>Please enter your full name</mat-error>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field class="max-zoom" class="width-350">
        <mat-label>Date Signed</mat-label>
        <input value="{{ date }}" matInput disabled>
      </mat-form-field>
    </div>
  </form>
</div>

<ng-template #loading>
  Loading Acknowledgement Information...
</ng-template>